import { provider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const PaketovyModul = {
	name: NAME,
	provider,
	router,
};
